import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "search",
  initialState: {
    pageNo: 0,
    industryKW: {},
    companyKW: {},
    numberKW:0,
    globalLoading: false,
  },
  reducers: {
    setPageNo(state, action) {
      state.pageNo = action.payload;
    },
    setGlobalLoading(state, action) {
      state.globalLoading = action.payload;
    },
    setIndustryKW(state, action) {
      state.industryKW = action.payload;
    },
    setCompanyKW(state, action) {
      state.companyKW = action.payload;
    },
    setNumberKW(state, action) {
      state.numberKW = action.payload;
    },
  },
});

export const searchActions = searchSlice.actions;

export default searchSlice;
